const e=async(e,t,n)=>{await e.delete(`/apps/${t}/system-roles/${n}`)};export{e as deleteSystemRole};
//# sourceMappingURL=delete-system-role.mjs.map